import React, { useEffect, useState } from "react";
import { Menu, Dropdown } from "@cloud/atom-ui";
import { i18n, locale } from "@src/utils/i18n";
import Headers from "../new-Header";
import * as nls from "./nls";
import useMappedState from "@src/utils/useMappedState";
import history from "@src/utils/history";
import { pclogout } from "./thunk";
import webConfig from "@src/configs/web.config";
import navMenuData, { rightMenuData } from "./const";

import Certification from "../Certification";
import { WEGO_TEN_LIST } from "./constants";
import constant from "@src/utils/constant";
import { doGet } from "@src/utils/toolkit";
import { urlDomainDeal } from "@src/utils/common";

const I18N = i18n(nls);
const text = I18N;
const lang = locale;
window._Dropdown = Dropdown; // cwp-react Headers 未引入 Dropdown 样式

function getCurrentUrl(isSystem) {
  return "1";
}

export default () => {
  const { user, siteType, tenant: tenantInfo } = useMappedState("root");
  // 判断是否购买appcube,跳转不同路径
  const [isPurchase, setIsPurchase] = useState(null);
  const appCubeUrl = window?.location?.hostname.includes('uat') ? constant.CLOUDUAT_URL : constant.OPEN_URL;

  if (!navMenuData) return null;
  if (navMenuData && siteType && siteType.site_type != 2) {
    navMenuData[2].resUrl = "#/wecode/doc";
    navMenuData[2].menuUrl = "#/wecode/doc";
    navMenuData[2].isHref = "1";
  }
  const headerUser = user || {};

  const applyCube = () => {
    const url = `/${process.env.REACT_APP_API_CONTEXT}/service/system/common/initMycData`;
    doGet(
      url,
      res => {
        setIsPurchase(res.isBuyAppCube);
        if (res.isBuyAppCube) {
          setIsPurchase(true);
        } else {
          setIsPurchase(false);
        }
      }
    );
  };
  useEffect(() => {
    applyCube();
  }, []);

  useEffect(() => {
    const children = [
      {
        //WeMax
        menuName: I18N["wemax"],
        key: "wemax",
        resUrl: webConfig.wemax,
        isShow: true,
        open: true
      },
      {
        //应用魔方
        menuName: I18N["applyCube"],
        key: "applyCube",
        resUrl: isPurchase ? appCubeUrl : constant.NOT_PURCHASED,
        isShow: true,
        open: true
      },
      {
        //WeGo
        menuName: I18N["weGo"],
        key: "weGo",
        resUrl: `${webConfig.openPlatformHome.weGo}?tenantId=${tenantInfo?.tenantId}`,
        isShow: WEGO_TEN_LIST?.includes(tenantInfo?.tenantId),
        open: true
      },
      {
        //We码雷达
        menuName: I18N["wecodeRadar"],
        key: "wecodeRadar",
        resUrl: webConfig.headNavigatUrl.weRadarUrl,
        isShow: true,
        open: true
      },
      {//ROMA 插件
        menuName: I18N['roma'],
        key: 'roma',
        resUrl: webConfig.headNavigatUrl.romaUrl,
        isShow: siteType && siteType.site_type != 2 ? (sessionStorage.getItem('canSeeRoma') ? sessionStorage.getItem('canSeeRoma') : user && user.canSeeRoma) : null
      },
    ];

    navMenuData[2].children = children;
  }, [isPurchase]);

  return (
    <Headers
      selectable={false}
      i18n={I18N}
      pageName={text.weOpen}
      lang={lang}
      user={{
        name: headerUser.displayName,
        nameEn: headerUser.displayName_En
      }}
      homeClick={() => {
        history.push("/home"); // 跳转路由
      }}
      navItemData={navMenuData}
      rightItems={rightMenuData}
      menuIndex="id"
      defaultSelectedKeys={[getCurrentUrl(headerUser.systemTenantid === "system")]}
      navItemClick={item => {
        if (item.isHref === "0") {
          window.location.href = urlDomainDeal(item.menuUrl);
        } else if (item.isHref === "1") {
          const url = (window.location.origin.indexOf("//open.") < 0 ? window.location.origin.replace("//", "//open.") + "/" : "") + item.menuUrl;

          window.open(url);
        } else if (item.isHref === "2") {
          window.open(urlDomainDeal(item.menuUrl));
        }
      }}
      rightItemClick={item => {
        window.open(urlDomainDeal(item.menuUrl));
      }}
      dropDownComponent={
        <Menu style={{ width: 318 }} defaultSelectedKeys={["5"]}>
          <Certification />
          <Menu.HeaderDivider />
          <Menu.Item
            key="1"
            style={{
              padding: "10px",
              wordBreak: "break-all",
              whiteSpace: "normal"
            }}
          >
            <div className="amu-headers-useranme">{lang === "zh" ? headerUser.displayName : headerUser.displayName_En}</div>
            <span className="amu-headers-email">{headerUser.accountid}</span>
          </Menu.Item>
          <Menu.HeaderDivider />
          {siteType && siteType.site_type == 2 ? null : (
            <Menu.Item>
              <div
                onClick={() => {
                  const link = "https://support.huaweicloud.com/admin-welink/start.html";
                  window.open(link);
                }}
              >
                {text.help}
              </div>
            </Menu.Item>
          )}
          <Menu.Item>
            <div
              onClick={() => {
                const link = "https://bbs.huaweicloud.com/forum/forum-964-1.html";
                window.open(link);
              }}
            >
              {I18N["searchHelp"]}
            </div>
          </Menu.Item>
          <Menu.HeaderDivider />
          {headerUser.systemTenantid !== "system" && <Menu.HeaderDivider />}
          <Menu.Item>
            <div
              onClick={async () => {
                const res = await pclogout();
                if (res === 200) {
                  sessionStorage.removeItem("ISVVALUE");
                  sessionStorage.removeItem("canSeeRoma");
                  window.location.href = webConfig.goLoginURl(window.location.href);
                }
              }}
            >
              {text.logOut}
            </div>
          </Menu.Item>
        </Menu>
      }
      logo={{
        url: `${require("@src/assets/logo1.png")}`,
        alt: "",
        style: { height: 20, width: 90 }
      }}
    />
  );
};
